import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

const tabStyle = css({
    backgroundColor: wacToken("color.neutral.light200"),
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    display: "flex",
    textAlign: "center",
    textDecoration: "none",
    height: 56,
    borderRadius: 28,
    paddingInlineEnd: 20,
    paddingInlineStart: 20,
    cursor: "pointer",
    border: `2px solid ${wacToken("color.neutral.light200")}`,
    fontWeight: 500,
    fontSize: "1.25rem",
    fontFamily: wacToken("font.charlie.display"),
    [":hover"]: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        border: "2px solid #0C66E4",
        backgroundColor: wacToken("color.extended.blue100")
    }
});

const selectedTabStyle = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    border: "2px solid #0C66E4",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#0C66E4"
});

export type IconTabsProps = {
    isSelected?: boolean;
    title: string;
};

export const RoundTab = ({ isSelected, title }: IconTabsProps) => {
    return <div css={[tabStyle, isSelected && selectedTabStyle]}>{title}</div>;
};
